import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const FailureIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 24),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    children: [/*#__PURE__*/jsx("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      stroke: "none"
    }), /*#__PURE__*/jsx("circle", {
      cx: "12",
      cy: "12",
      r: "11.25"
    }), /*#__PURE__*/jsx("path", {
      d: "M12 5.5v9",
      strokeLinecap: "round"
    }), /*#__PURE__*/jsxs("g", {
      fill: color ?? svgProps.fill ?? "currentColor",
      children: [/*#__PURE__*/jsx("circle", {
        cx: "12",
        cy: "18",
        r: "1",
        stroke: "none"
      }), /*#__PURE__*/jsx("circle", {
        cx: "12",
        cy: "18",
        r: ".5"
      })]
    })]
  });
};

export { FailureIcon };
//# sourceMappingURL=failure.js.map
